import { useCallback } from 'react'
import { GameMode, GameState } from '../types'
import * as gameLogic from '../services/gameLogic'

export const useNavigation = (
  params: {
    gameMode: GameMode
    lastGameMode: GameMode
    setGameMode: (v: GameMode) => void
    setLastGameMode: (v: GameMode) => void
    setWsError: (v: string | null) => void
    setShowInGameMenu: (v: boolean | ((prev: boolean) => boolean)) => void
    setGameState: (v: GameState | null) => void
    setPlayerIsReady: (v: boolean) => void
    setAnimations: (v: any) => void
    resetDragState?: () => void
  }
) => {
  const { gameMode, lastGameMode, setGameMode, setLastGameMode, setWsError, setShowInGameMenu, setGameState, setPlayerIsReady, setAnimations, resetDragState } = params

  const toggleInGameMenu = useCallback(() => setShowInGameMenu((prev: boolean) => !prev), [setShowInGameMenu])

  const handleNavigate = useCallback((mode: GameMode) => {
    setLastGameMode(gameMode)
    setGameMode(mode)
    setWsError(null)
  }, [gameMode, setLastGameMode, setGameMode, setWsError])

  const handleStartGame = useCallback((seed?: string, playerName?: string) => {
    setPlayerIsReady(false)
    setAnimations([])
    if (resetDragState) resetDragState()
    setGameState(gameLogic.initGame(seed, playerName ? [{ name: playerName }, { name: 'AI', isAI: true }] : undefined))
    setGameMode('PLAYING')
  }, [setPlayerIsReady, setAnimations, setGameState, setGameMode, resetDragState])

  const handleRestart = useCallback((seed?: string) => {
    setPlayerIsReady(false)
    setAnimations([])
    if (resetDragState) resetDragState()
    setGameState(gameLogic.initGame(seed))
  }, [setPlayerIsReady, setAnimations, setGameState, resetDragState])

  const handleBack = useCallback(() => {
    if (gameMode === 'CREATE_ROOM' || gameMode === 'JOIN_ROOM') {
      setGameMode('MULTIPLAYER_MENU')
    } else {
      setGameMode(lastGameMode)
    }
    setWsError(null)
  }, [gameMode, lastGameMode, setGameMode, setWsError])

  return {
    toggleInGameMenu,
    handleNavigate,
    handleStartGame,
    handleRestart,
    handleBack,
  }
}

